export const DIRECT_CHAT_ROOM = "direct";
export const GROUP_CHAT_ROOM = "group_chat";
export const ENTER_KEY_CODE = 13;
export const ESCAPE_KEY_CODE = 27;
export const DOWN_KEY_CODE = 40;
export const UP_KEY_CODE = 38;
export const DELETE_KEY_CODE = 46;
export const BACKSPACE_KEY_CODE = 8;
export const GDPR_COOKIE_NAME = "circle_gdpr_cookies_enabled";
export const CIRCLE_DOMAIN = "circle.so";
export const STANDARD_LAYOUT_V2_COVER_IMAGE_CONTAINER =
  "standard-layout-v2-cover-image-container";

export const ASPECT_RATIO = {
  COMMUNITY_ICON: 1, // 1:1
  COMMUNITY_LOGO: 4, // 4:1
  COMMUNITY_LOGO_V3: 6.3888, // 115:18 (e.g., 230x36 or 460x72)
  COVER_V3: 3.2, // 16:5
  DEFAULT: 2.8, // 14:5
  OPEN_GRAPH: 1.9, // 19:10
  SPACE_COVER: 4.777, // 43:9
  SPACE_THUMBNAIL: 16 / 9, // 16:9
  THUMBNAIL: 2, // 2:1
  PAYWALL_COVER_IMAGE: 1.78, // 540 x 303.48
  PAYWALL_AVATAR_IMAGE: 1, // 1:1,
};

export type AspectRatio = keyof typeof ASPECT_RATIO;

export const POST_FORM_CACHE = "posts-form-cache";
export const CHAT_MESSAGE_DRAFT_CACHE_PREFIX = "chat-message-draft-";
export const MESSAGE_REPORT_ACTIONS_QUERY_KEY = "messageReportActions";

export const ONLINE_STATUS = {
  online: "online",
  idle: "idle",
  offline: "offline",
} as const;

export const MOUSETRAP_ACTIONS = {
  OPEN_SEARCH_MODAL: ["command+k", "ctrl+k"],
};

export const CHAT_THREADS_BANNER_LOCAL_STORAGE_KEY =
  "display-chat-threads-banner";

export const MESSAGING_MODAL_PORTAL_ID = "direct-messaging-modal";
export const MESSAGING_PAGE_OVERLAY_ID = "direct-messaging-page-overlay";
export const CHAT_THREADS_HEADER_ID = "chat-threads-header";

export const MOBILE_BOTTOM_TOOLBAR_ID = "mobile-bottom-toolbar";
